'use client'

import YoutubePlayer from '@page/live/_component/LiveHead/LivePlayer/YoutubePlayer'
import color from '@ui/style/color.theme'

import UIText from '@components/ui/UIText'
import UIFlex from '@components/ui/UIFlex'

import ContentBadge from '@components/content/ContentBadge'
import { ArticleItemProps } from '@components/list'
import { getRelativeTime } from '@utils/date'
import ContentBullet from '../ContentCard/ContentInfo/ContentBullet'
import { Box } from '@mui/joy'
import pxToRem from '@utils/pxToRem'
import MuiLink from '@mui/joy/Link'

interface YoutubeContentCardProps {
	article1st: ArticleItemProps
	isDark?: boolean
}

const YoutubeContentCard = ({ article1st, isDark }: YoutubeContentCardProps) => {
	return (
		<UIFlex
			color="initial"
			flexDirection="column"
			alignItems="stretch"
			position="relative"
			flex={1}
		>
			<Box margin={{ lg: 0, md: 0, xs: `0 ${pxToRem(-20)}` }}>
				<YoutubePlayer
					liveLinkUrl={article1st?.youtubeLiveUrl || 'https://www.youtube.com/embed'}
					autoPlayStatus="autoplay=1"
				/>
			</Box>
			<Box
				margin={{
					md: `${pxToRem(16)} 0 0 0`,
					xs: `${pxToRem(16)} 0 ${pxToRem(20)} 0`,
				}}
			>
				{article1st.code === 'LIVE' && article1st.liveTagTypeCode && (
					<Box display="inline-block" lineHeight={0} marginBottom={pxToRem(8)}>
						<ContentBadge
							contentType="LIVE"
							liveTagTypeCode={article1st.liveTagTypeCode}
							withBorder={article1st.liveTagTypeCode !== 'ONAIR'}
						/>
					</Box>
				)}
				<UIText
					level="HeadingL"
					color={isDark ? color.colWhite : color.colBlack}
					marginBottom={pxToRem(8)}
				>
					<MuiLink href={`/live/${article1st.liveIdx}`} underline="none">
						<UIText
							sx={{
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								display: '-webkit-box',
								WebkitBoxOrient: 'vertical',
								fontSize: {
									xl: pxToRem(32),
									lg: pxToRem(28),
									md: pxToRem(26),
									sm: pxToRem(26),
								},
								lineHeight: {
									xl: pxToRem(42),
									lg: pxToRem(36),
									md: pxToRem(34),
									sm: pxToRem(36),
								},
								WebkitLineClamp: {
									xl: 1,
									lg: 1,
									md: 1,
									sm: 3,
								},
								color: isDark ? color.colWhite : color.colBlack,
								textAlign: 'left',
								'&:hover': {
									color: color.colGray5,
								},
							}}
						>
							<ContentBullet
								bullet={article1st.bulletType && article1st.bulletType.name}
							/>
							{article1st.articleTitle}
						</UIText>
					</MuiLink>
				</UIText>
				<UIText
					color={color.colGray5}
					fontSize={{ xs: pxToRem(14), md: pxToRem(15) }}
					fontWeight={500}
					lineHeight={pxToRem(16)}
				>
					{getRelativeTime(article1st.publicationDate ?? '', article1st.code === 'LIVE')}
				</UIText>
			</Box>
		</UIFlex>
	)
}

export default YoutubeContentCard
